import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { UsersService } from '@app/services/users.service';
import { DeviceService } from '@app/services/device.service';

@Injectable({ providedIn: 'root' })
export class IsLoggedGuard {
    private readonly router = inject(Router);
    private readonly usersService = inject(UsersService);
    private readonly deviceService = inject(DeviceService);

    isDesktop: boolean;

    constructor() {
        this.deviceService.isDesktopObservable.subscribe((isDesktop: boolean) => {
            this.isDesktop = isDesktop;
        });
    }

    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        const isTokenExpired = this.usersService.isTokenExpired();
        if (isTokenExpired) {
            return true;
        }
        const isLoginByMagicLink = !!route.queryParams.token && !!route.queryParams.userId;
        const authenticated = await this.usersService.checkLogin();
        if (authenticated && !isLoginByMagicLink) {
            return this.router.createUrlTree([this.isDesktop ? '/dashboard' : '/mobile/dashboard'], {
                queryParams: { unsubscribe: route.queryParams.unsubscribe },
            });
        } else {
            return true;
        }
    }
}
